import {useIntl} from 'react-intl'
import {formatPhoneNumber} from '../../utils/phone-utils'
import {useBrand} from '../../contexts/brand-context'


export default function useCommunicationsFields({
    form: {
        control,
        formState: {errors}
    },
    prefix = ''
}) {
    const {formatMessage} = useIntl()

    const switchLabels = {
        on: formatMessage({
            id: 'communication_preferences.email.subscribe',
            defaultMessage: 'Subscribed'
        }),
        off: formatMessage({
            id: 'communication_preferences.email.unsubscribe',
            defaultMessage: 'Unsubscribed'
        })
    }

    const {isGarage} = useBrand()

    const fields = {
        emailPromotionalOptIn: {
            name: `${prefix}emailPromotionalOptIn`,
            type: 'switch',
            control,
            error: errors[`${prefix}emailPromotionalOptIn`],
            defaultValue: false,
            switchLabels,
            switchProps: {
                sx: {
                    '&[data-checked] .chakra-switch__track': {
                        bg: 'black'
                    }
                }
            }
        },

        emailPersonalizedOptIn: {
            name: `${prefix}emailPersonalizedOptIn`,
            type: 'checkbox',
            control,
            error: errors[`${prefix}emailPersonalizedOptIn`],
            defaultValue: false,
            label: formatMessage(
                isGarage
                    ? {
                          id: 'account_detail.preferences.ai_recommendations.garage',
                          defaultMessage:
                              'I also want to receive recommendations picked for me through AI and automated profiling.'
                      }
                    : {
                          id: 'account_detail.preferences.ai_recommendations.dynamite',
                          defaultMessage:
                              'I also want to receive recommendations picked for me through AI and automated profiling.'
                      }
            ),
            labelProps: {
                fontSize: '12px',
                fontWeight: '400',
                color: '#585858'
            }
        },

        smsPhoneNumber: {
            name: `${prefix}smsPhoneNumber`,
            type: 'tel',
            placeholder: formatMessage({
                id: 'communication_preferences.sms.phone_label',
                defaultMessage: 'Phone Number (optional)'
            }),
            rules: {
                required: formatMessage({
                    id: 'communication_preferences.sms.phone_required',
                    defaultMessage: 'Phone number is required'
                }),
                pattern: {
                    value: /^[+]?[(]?[\d\s\-\(\)]{10,}$/,
                    message: formatMessage({
                        id: 'communication_preferences.sms.phone_invalid',
                        defaultMessage: 'Please enter a valid phone number'
                    })
                }
            },
            error: errors[`${prefix}smsPhoneNumber`],
            control,
            inputProps: ({onChange}) => ({
                inputMode: 'numeric',
                'data-testid': 'communication-sms-phone-input',
                onChange(evt) {
                    onChange(formatPhoneNumber(evt.target.value))
                },
                sx: {
                    border: '1px solid #939393',
                    padding: '8px',
                    height: '48px',
                    fontSize: '14px'
                }
            }),
            hideLabel: true
        },

        languagePreference: {
            name: `${prefix}languagePreference`,
            type: 'radio',
            options: [
                {
                    label: formatMessage({
                        id: 'account_detail.language.french',
                        defaultMessage: 'French (Français)'
                    }),
                    value: 'fr'
                },
                {
                    label: formatMessage({
                        id: 'account_detail.language.english',
                        defaultMessage: 'English'
                    }),
                    value: 'en'
                }
            ],
            rules: {
                required: formatMessage({
                    id: 'account_detail.language.required',
                    defaultMessage: 'Please select a language'
                })
            },
            error: errors[`${prefix}languagePreference`],
            control,
            defaultValue: 'fr'
        }
    }

    return fields
}
